export default __webpack_public_path__ + "static/media/faq_img.1bf7756a.png";